import React from 'react';
import './Upload.scss';

import uploadIcon from './file-upload.svg';
import Button from '../button';

interface CustomProps {
  id: string;
  title: string;
  description?: string;
  filename: string;
  fileSize: string;
  progress?: number;
  onClose?: () => void;
  disabled?: boolean;
  hideLabel?: boolean;
  sm?: boolean;
}

const FileUploading: React.SFC<CustomProps> = (props) => {
  return (
    <>
      {!props.hideLabel && <label className="fieldlabel">{props.title}</label>}

      <div className="uploadfile uploadfile--border uploadfile--curve uploaded">
        <div
          className="uploadfile__progress-bar"
          style={{ width: `${(props.progress || 0) * 100}%` }}
        ></div>
        <div className={`uploadfile__outer uploadfile--spacing ${props.sm === true ? 'py-2 px-3' : ''}`}>
          <label className="uploadfile__label">
            <span className="uploadfile__filename">
              <div className={`uploadfile__icon ${props.sm === true ? 'pr-2 mr-1' : 'px-2'}`}>
                <img src={uploadIcon} alt="" />
              </div>
              <span className="uploadfile__filename-outer">
                <span className={`uploadfile__filename-text ${props.sm === true ? 'font-sm' : ''}`}>
                  {props.filename}
                </span>
                <span className={`uploadfile__filename-subtext ${props.sm === true ? 'font-xxs mt-0' : ''}`}>
                  {`${((props.progress || 0) * 100).toFixed(0)}%`}
                </span>
              </span>
            </span>
          </label>
          {!props.disabled && (
            <Button type="button" btnlink onClick={props.onClose}>
              <span className="uploadfile__close">
                <i className={`icon-close uploadfile__close-icon ${props.sm === true ? 'text-gray-500' : ''}`}></i>
              </span>
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default FileUploading;
